import * as THREE from "three";

import type { PlanePool } from "./PlanePool";
import { initFilmWorkListing } from "./FilmWorkListing";
import { initMusicWorkListing } from "./MusicWorkListing";

export interface OriginalMedia {
    texture: THREE.Texture;
    aspect: number;
}

const listingDisposers = new WeakMap<HTMLElement, () => void>();

function initListing(planePool: PlanePool, listing: HTMLElement): () => void {
    const dispose = listing.dataset.site === "music" ? initMusicWorkListing(planePool, listing) : initFilmWorkListing(planePool, listing);
    listingDisposers.set(listing, dispose);
    return dispose;
}

export function initWorkListing(planePool: PlanePool, container: HTMLElement): () => void {
    const listings = container.matches("[data-listing='work']") ? [container] : Array.from(container.querySelectorAll<HTMLElement>("[data-listing='work']"));

    const disposers = listings.map(listing => initListing(planePool, listing));

    return () => {
        disposers.forEach(dispose => dispose());
    };
}

export function refreshWorkListing(planePool: PlanePool, listing: HTMLElement): void {
    listingDisposers.get(listing)?.();
    initListing(planePool, listing);
}

// util function used by both film and music listings
export function findSiblingVideo(el: HTMLElement): HTMLVideoElement | null {
    const parent = el.parentElement;
    if (!parent) return null;
    for (const sibling of Array.from(parent.children)) {
        if (sibling === el) continue;
        const video = sibling.querySelector<HTMLVideoElement>("video");
        if (video) return video;
    }
    return null;
}
